'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Constants = require('./Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _FrameworkState = require('./core/FrameworkState');

var _FrameworkState2 = _interopRequireDefault(_FrameworkState);

var _PluginState = require('./PluginState');

var _PluginState2 = _interopRequireDefault(_PluginState);

var _ServiceAction = require('./ServiceAction');

var _ServiceAction2 = _interopRequireDefault(_ServiceAction);

var _ExtensionAction = require('./ExtensionAction');

var _ExtensionAction2 = _interopRequireDefault(_ExtensionAction);

var _Extension = require('./Extension');

var _Extension2 = _interopRequireDefault(_Extension);

var _MinimaConfiguration = require('./MinimaConfiguration');

var _MinimaConfiguration2 = _interopRequireDefault(_MinimaConfiguration);

var _Framework = require('./core/Framework');

var _Framework2 = _interopRequireDefault(_Framework);

var _log = require('./utility/log');

var _log2 = _interopRequireDefault(_log);

var _Assert = require('./utility/Assert');

var _Assert2 = _interopRequireDefault(_Assert);

var _ServiceRegistry = require('./ServiceRegistry');

var _ServiceRegistry2 = _interopRequireDefault(_ServiceRegistry);

var _Plugin = require('./Plugin');

var _Plugin2 = _interopRequireDefault(_Plugin);

var _PluginContext = require('./PluginContext');

var _PluginContext2 = _interopRequireDefault(_PluginContext);

var _PluginConfiguration = require('./PluginConfiguration');

var _PluginConfiguration2 = _interopRequireDefault(_PluginConfiguration);

var _PluginInstaller = require('./core/PluginInstaller');

var _PluginInstaller2 = _interopRequireDefault(_PluginInstaller);

var _PluginResolver = require('./core/PluginResolver');

var _PluginResolver2 = _interopRequireDefault(_PluginResolver);

var _PluginStarter = require('./core/PluginStarter');

var _PluginStarter2 = _interopRequireDefault(_PluginStarter);

var _EventManager = require('./core/EventManager');

var _EventManager2 = _interopRequireDefault(_EventManager);

var _ServiceManager = require('./service/ServiceManager');

var _ServiceManager2 = _interopRequireDefault(_ServiceManager);

var _ExtensionManager = require('./plugin/ExtensionManager');

var _ExtensionManager2 = _interopRequireDefault(_ExtensionManager);

var _Version = require('./Version');

var _Version2 = _interopRequireDefault(_Version);

var _path = require('path');

var _path2 = _interopRequireDefault(_path);

var _fs = require('fs');

var _fs2 = _interopRequireDefault(_fs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 创建一个Minima插件框架
 * 
 * @example
 * //1 创建插件框架、启动并从插件集合目录加载运行插件
 * let minima = new Minima(__dirname + './plugins');
 * 
 * // 2 注册全局服务（可以忽略该步骤）
 * let myService = new MyService();
 * minima.addService('myService', myService);
 * 
 * // 3 启动插件框架
 * minima.start();
 * 
 * // 4 获取插件
 * let plugin = minima.getPlugin('demoPlugin');
 * 
 * // 5 停止插件框架
 * minima.stop();
 * 
 * @export
 * @class Minima
 */
var Minima = function () {
    /**
     * 创建一个插件框架
     * 
     * @ignore
     * @param {string[]} pluginsDirectories 插件集合目录 
     * @memberof Minima
     */
    function Minima() {
        for (var _len = arguments.length, pluginsDirectories = Array(_len), _key = 0; _key < _len; _key++) {
            pluginsDirectories[_key] = arguments[_key];
        }

        (0, _classCallCheck3.default)(this, Minima);

        if (pluginsDirectories === null || pluginsDirectories.length === 0) {
            pluginsDirectories = [];
            var defaultPluginsDirectories = [_path2.default.resolve('./plugins'), _path2.default.resolve('./node_modules')];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(defaultPluginsDirectories), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var defaultPluginsDirectory = _step.value;

                    if (_fs2.default.existsSync(defaultPluginsDirectory)) {
                        pluginsDirectories.push(defaultPluginsDirectory);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            _Assert2.default.notEmptyArray('pluginsDirectories', pluginsDirectories);
        } else {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(pluginsDirectories), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var pluginsDirectory = _step2.value;

                    _Assert2.default.notExists(pluginsDirectory);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }

        Minima.instance = this;

        this.pluginsDirectories = pluginsDirectories;
        this.startLevel = _MinimaConfiguration2.default.startLevel;

        this._framework = new _Framework2.default(this);
        this.start = this.start.bind(this);
        this.stop = this.stop.bind(this);

        this.addService = this.addService.bind(this);
        this.getServices = this.getServices.bind(this);
        this.getDefaultService = this.getDefaultService.bind(this);
        this.removeService = this.removeService.bind(this);

        this.getExtensions = this.getExtensions.bind(this);

        this.getPlugin = this.getPlugin.bind(this);
        this.getPlugins = this.getPlugins.bind(this);

        this.addPluginStateChangedListener = this.addPluginStateChangedListener.bind(this);
        this.removePluginStateChangedListener = this.removePluginStateChangedListener.bind(this);

        this.addServiceChangedListener = this.addServiceChangedListener.bind(this);
        this.removeServiceChangedListener = this.removeServiceChangedListener.bind(this);

        this.addExtensionChangedListener = this.addExtensionChangedListener.bind(this);
        this.removeExtensionChangedListener = this.removeExtensionChangedListener.bind(this);
    }

    /**
     * 内部框架类
     * 
     * @readonly
     * @memberof Minima
     */

    /**
     * 插件框架静态实例
     * 
     * @type {Minima}
     * @static
     * @memberof Minima
     */


    (0, _createClass3.default)(Minima, [{
        key: 'addService',


        /**
         * 注册全局服务
         * 
         * @param {string} serviceName 服务名称
         * @param {Object} serviceInstance 服务实例
         * @param {Object} [properties={}] 服务注册属性，用于服务的绑定过滤
         * @returns {ServiceRegistry} 返回服务注册表对象
         * @memberof Minima
         */
        value: function addService(serviceName, serviceInstance) {
            var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            if (!properties.global) {
                properties.global = true;
            }
            return this._framework.serviceManager.add(serviceName, serviceInstance, this, properties);
        }

        /**
         * 删除一个服务
         * 
         * @param {ServiceRegistry} serviceRegistry 服务注册表
         * @memberof Minima
         */

    }, {
        key: 'removeService',
        value: function removeService(serviceRegistry) {
            this._framework.serviceManager.remove(serviceRegistry);
        }

        /**
         * 获取匹配的所有服务实例，注意，返回的服务没有了Properties，不合适。
         * 
         * @param {string} name 服务名称
         * @param {Object} properties 服务过滤属性
         * @returns {ServiceRegistry[]} 服务实例的集合
         * @memberof Minima
         */

    }, {
        key: 'getServices',
        value: function getServices(name, properties) {
            return this._framework.serviceManager.findServices(name, properties);
        }

        /**
         * 匹配一个服务
         * 
         * @param {string} name 服务名称
         * @param {Object} properties 服务过滤属性
         * @returns {Object} 服务实例
         * @memberof Minima
         */

    }, {
        key: 'getDefaultService',
        value: function getDefaultService(name, properties) {
            return this._framework.serviceManager.findDefaultService(name, properties);
        }

        /**
         * 获取插件实例
         * 
         * @param {string} id 插件id
         * @returns {Plugin} 返回指定id的插件
         * @memberof Minima
         */

    }, {
        key: 'getPlugin',
        value: function getPlugin(id) {
            return this._framework.pluginInstaller.getPlugin(id);
        }

        /**
         * 获取所有插件
         * 
         * @returns {Map.<string, Plugin>} 插件Map
         * @memberof Minima
         */

    }, {
        key: 'getPlugins',
        value: function getPlugins() {
            return this._framework.pluginInstaller.getPlugins();
        }

        /**
         * 获取扩展点信息
         * 
         * @param {string} id 扩展点id
         * @returns {Set.<Extension>} 扩展点集合
         * @memberof Minima
         */

    }, {
        key: 'getExtensions',
        value: function getExtensions(id) {
            return this._framework.extensionManager.find(id);
        }

        /**
         * 添加插件状态监听器
         * 
         * @param {function} listener 监听器函数
         * @example
         * pluginStateChangedListener(id, previous, current) {
         *     // ...
         * }
         * @memberof PluginContext
         */

    }, {
        key: 'addPluginStateChangedListener',
        value: function addPluginStateChangedListener(listener) {
            this._framework.eventManager.addPluginStateChangedListener(listener);
        }

        /**
         * 删除插件状态监听器
         * 
         * @param {function} listener 监听器函数
         * @memberof PluginContext
         */

    }, {
        key: 'removePluginStateChangedListener',
        value: function removePluginStateChangedListener(listener) {
            this._framework.eventManager.removePluginStateChangedListener(listener);
        }

        /**
         * 添加服务变更监听器
         * 
         * @param {function} listener 监听器函数
         * @example 
         * serviceChangedListener(name, action) {
         * }
         * @memberof PluginContext
         */

    }, {
        key: 'addServiceChangedListener',
        value: function addServiceChangedListener(listener) {
            this._framework.eventManager.addServiceChangedListener(listener);
        }

        /**
         * 删除服务变更监听器
         * 
         * @param {function} listener 监听器函数
         * @memberof PluginContext
         */

    }, {
        key: 'removeServiceChangedListener',
        value: function removeServiceChangedListener(listener) {
            this._framework.eventManager.removeServiceChangedListener(listener);
        }

        /**
         * 添加扩展变更监听器
         * 
         * @param {function} listener 监听器函数
         * @example
         * extensionChangedListener(extension, action) {
         *     // ......
         * }
         * @memberof PluginContext
         */

    }, {
        key: 'addExtensionChangedListener',
        value: function addExtensionChangedListener(listener) {
            this._framework.eventManager.addExtensionChangedListener(listener);
        }

        /**
         * 删除扩展变更监听器
         * 
         * @param {function} listener 监听器函数
         * @memberof PluginContext
         */

    }, {
        key: 'removeExtensionChangedListener',
        value: function removeExtensionChangedListener(listener) {
            this._framework.eventManager.removeExtensionChangedListener(listener);
        }

        /**
         * 启动插件框架
         * 
         * @memberof Minima
         */

    }, {
        key: 'start',
        value: function start() {
            this._framework.start();
        }

        /**
         * 停止插件框架
         * 
         * @memberof Minima
         */

    }, {
        key: 'stop',
        value: function stop() {
            this._framework.stop();
        }
    }, {
        key: 'framework',
        get: function get() {
            return this._framework;
        }
    }]);
    return Minima;
}();

Minima.instance = null;
exports.default = Minima;


exports.Constants = _Constants2.default;
exports.Minima = Minima;
exports.FrameworkState = _FrameworkState2.default;
exports.PluginState = _PluginState2.default;
exports.ServiceAction = _ServiceAction2.default;
exports.ExtensionAction = _ExtensionAction2.default;
exports.log = _log2.default;
exports.Assert = _Assert2.default;
exports.ServiceRegistry = _ServiceRegistry2.default;
exports.Plugin = _Plugin2.default;
exports.PluginContext = _PluginContext2.default;
exports.PluginConfiguration = _PluginConfiguration2.default;
exports.PluginInstaller = _PluginInstaller2.default;
exports.PluginResolver = _PluginResolver2.default;
exports.PluginStarter = _PluginStarter2.default;
exports.EventManager = _EventManager2.default;
exports.ServiceManager = _ServiceManager2.default;
exports.ExtensionManager = _ExtensionManager2.default;
exports.Extension = _Extension2.default;
exports.Version = _Version2.default;
//# sourceMappingURL=Minima.js.map